import { useTranslation } from 'react-i18next';
import { CONSENT_DECISION, type ConsentDecision } from '@/constants/consents';
import { cn } from '@/lib/utils';

type ToggleSize = 'sm' | 'md';

const SIZE_CLASS: Record<ToggleSize, string> = {
  sm: 'px-3 py-1',
  md: 'px-4 py-1.5',
};

interface ConsentDecisionToggleProps {
  value: ConsentDecision | null;
  onSelect: (decision: ConsentDecision) => void;
  isDisabled?: boolean;
  size?: ToggleSize;
}

export function ConsentDecisionToggle({
  value,
  onSelect,
  isDisabled = false,
  size = 'md',
}: ConsentDecisionToggleProps) {
  const { t } = useTranslation('common');
  const choices: ConsentDecision[] = [CONSENT_DECISION.agreed, CONSENT_DECISION.declined];
  return (
    <div className="inline-flex bg-zoooffwhite border border-zooborder rounded-lg p-1">
      {choices.map(function renderChoice(choice) {
        const isSelected = value === choice;
        return (
          <button
            key={choice}
            type="button"
            aria-pressed={isSelected}
            disabled={isDisabled}
            onClick={function pick() {
              onSelect(choice);
            }}
            className={cn(
              'rounded-md text-xs font-bold transition-colors',
              SIZE_CLASS[size],
              isSelected
                ? choice === CONSENT_DECISION.agreed
                  ? 'bg-zoosuccessbg text-zoosuccesstext'
                  : 'bg-zooerrorbg text-zooerrortext'
                : 'text-zoomuted'
            )}
          >
            {choice === CONSENT_DECISION.agreed
              ? t('consentDecision.agreed')
              : t('consentDecision.declined')}
          </button>
        );
      })}
    </div>
  );
}
